import { useEffect } from 'react';
import { toast } from 'sonner';
import { wsClient } from '@/lib/ws';
import { backendUrl } from '@/lib/bubbleImage';
import { useAuth } from '@/lib/auth';

/**
 * AlmanacListener — top-level invisible component that listens for the
 * server's `almanac_whisper` WS event (the 7am-local-time push). When it
 * arrives, surface a toast with a "Play" button that plays the voicemail mp3.
 */
const AlmanacListener = () => {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return undefined;
    return wsClient.onEvent((data) => {
      if (data?.type !== 'almanac_whisper') return;
      if (data.payload?.user_id && data.payload.user_id !== user.id) return;
      const url = data.payload?.voicemail_url;
      toast.message(
        data.payload?.whisper || 'your bubble has something to say',
        {
          duration: 12000,
          action: url ? {
            label: '▶ play',
            onClick: () => {
              try {
                const a = new Audio(backendUrl(url));
                a.play().catch(() => {});
              } catch { /* ignore */ }
            },
          } : undefined,
        },
      );
    });
  }, [user?.id]); // eslint-disable-line
  return null;
};

export default AlmanacListener;
